<template>
  <v-container class="payment-container">
    <v-expansion-panel popout light class="futuristic-expansion">
      <v-expansion-panel-content>
        <template v-slot:header>
          <div>
            <h4 class="earth-color">GLOBAL SEARCH</h4>
            <div class="title-decoration"></div>
          </div>
        </template>
        <template v-slot:actions>
          <v-icon color="#587e27">$vuetify.icons.expand</v-icon>
        </template>
        <search-tabs></search-tabs>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-card flat class="futuristic-card">
      <v-card-title class="card-header">
        <div>
          <h4 class="earth-color">Booking Residency Proofs</h4>
          <div class="title-decoration"></div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search"
          class="futuristic-search"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="columns"
        :items="getAllBookingProofs"
        :search="search"
        :pagination.sync="pagination"
        :disable-initial-sort="true"
        :loading="$loadingTrue"
        class="futuristic-table"
      >
        <v-progress-linear slot="progress" color="#587e27" indeterminate></v-progress-linear>
        <template v-slot:items="props">
          <td data-label="Booking Ref">
            <router-link
              :to="{
                name: 'Booking',
                params: { booking_id: props.item.booking_public_id },
              }"
              target="_blank"
            >
              <a class="futuristic-link">{{ props.item.booking_ref_code }}</a>
            </router-link>
          </td>
          <td data-label="Name">{{ props.item.first_name }} {{ props.item.last_name }}</td>
          <td data-label="Residency">{{ props.item.residency.payment_person }}</td>
          <td data-label="Point Of Proof">{{ props.item.proof_point }}</td>
          <td data-label="Document Id">{{ props.item.document_id }}</td>
          <td data-label="Verified" :style="props.item.booking_color">{{ props.item.verified }}</td>
          <td data-label="Creation Date">{{ formated_date(props.item.created_at) }}</td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 sm6 md4 lg3>
            <v-select
              :items="rowsPerPageItems"
              v-model="pagination.rowsPerPage"
              label="Rows per page"
              class="futuristic-input"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6>
            <v-btn
              :depressed="true"
              color="#587e27"
              @click="getMore()"
              :loading="this.$store.state.LoadingStore.loading"
              class="futuristic-btn"
            >GET MORE PROOFS</v-btn>
            <vue-json-to-csv
              :json-data="getProofsCSV"
              csv-title="Booking Alerts"
              :labels="{
                booking_ref_code: { title: 'Booking Ref' },
                name: { title: 'Guest Name' },
                residency: { title: 'Residency' },
                document_id: { title: 'Document Id' },
                verified: { title: 'Verified' },
                verified_by: { title: 'Verified By' },
                created_at: { title: 'Creation Date' },
              }"
            >
              <v-btn
                :depressed="true"
                color="#f1c40f"
                :loading="$loadingTrue"
                class="futuristic-btn"
              >Download Proofs(CSV)</v-btn>
            </vue-json-to-csv>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import SearchTabs from "./FindBooking";
import VueJsonToCsv from "vue-json-to-csv";
export default {
  components: { SearchTabs, VueJsonToCsv },
  name: "BookingsAlert",
  data() {
    return {
      search: "",
      update_alert_dialog: false,
      alert_updates: false,
      term: {
        key: "",
      },
      page: 2,
      columns: [
        {
          text: "Booking ref",
          value: "booking_ref_code",
        },
        {
          text: "Name",
          value: "first_name",
        },
        {
          text: "Residency",
          value: "residency",
        },
        {
          text: "Point Of Proof",
          value: "proof_point",
        },
        {
          text: "Document Id",
          value: "document_id",
        },
        {
          text: "Verified",
          value: "verified",
        },
        {
          text: "Creation date",
          value: "created_at",
        },
      ],
      pagination: {
        rowsPerPage: 10
      },
      rowsPerPageItems: [10, 25, { text: 'All', value: -1 }],
    };
  },
  created() {
    this.$store.dispatch("get_bookings_residency_proof");
  },
  methods: {
    getMore() {
      this.loading = true;
      if (this.page === 2) {
        this.$store.dispatch("get_more_streamed_proofs", this.page);
        this.page = this.page + 1;
      } else {
        this.$store.dispatch("get_more_streamed_proofs", this.page);
        this.page = this.page + 1;
      }
    },
    updateViewAlertUpdate: function (note_id) {
      this.$router.push({
        name: "ViewUpdateAlert",
        params: {
          note_id: note_id,
        },
      });
    },
    searchTerm: function () {
      this.$store.dispatch("search_inspect_booking_by_key", this.term);
    },
    getUnticketed: function () {
      this.$router.push({
        name: "BookingUnticketedAlert",
      });
    },
  },
  computed: {
    getProofsCSV: function () {
      let all_proofs = this.$store.state.BookingStore.all_residency_proof;
      let proofs_arr = [];
      if (all_proofs.length > 0) {
        for (let i = 0; i < all_proofs.length; i++) {
          let proofs_obj = {};
          proofs_obj["booking_ref_code"] = all_proofs[i].booking_ref_code;
          proofs_obj["name"] =
            all_proofs[i].first_name + " " + all_proofs[i].last_name;
          proofs_obj["residency"] = all_proofs[i].residency.payment_person;
          proofs_obj["document_id"] = all_proofs[i].document_id;
          proofs_obj["verified"] = all_proofs[i].verified;
          proofs_obj["verified_by"] = all_proofs[i].user;
          proofs_obj["created_at"] = this.formated_date(
            all_proofs[i].created_at
          );
          proofs_arr.push(proofs_obj);
        }
      }
      return proofs_arr;
    },
  },
};
</script>

<style scoped>
/* Futuristic Container */
.payment-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.payment-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-expansion {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-expansion:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.futuristic-table {
  border-radius: 8px;
  background: #ffffff;
}

.futuristic-table >>> th {
  color: #587e27;
  font-weight: 600;
}

.futuristic-link {
  color: #587e27;
  text-decoration: none;
  transition: color 0.2s ease;
}

.futuristic-link:hover {
  color: #1b5e20;
}

.futuristic-alert {
  border-radius: 8px;
  background: #fff5f5;
}

.futuristic-search >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .payment-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.25rem;
  }

  .futuristic-btn {
    font-size: 0.9rem;
  }
}

@media (max-width: 600px) {
  .payment-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.1rem;
  }

  .futuristic-btn {
    font-size: 0.85rem;
  }
}
</style>